import {AgeGrade, User} from '../graphql/generated/types';
import {AGE_GRADE_TO_NUMBER_MAP} from './constant';
import {getIsNowOverAYear} from './getIsNowOverAYear';

export function getShouldSelfCertToAccessContent({
  ageGrade,
  userAge,
  userAuthenticatedAt,
}: {
  ageGrade: AgeGrade;
  userAge?: User['age'];
  userAuthenticatedAt?: User['authenticatedAt'];
}): boolean {
  // 작품 등급이 19세 이상인 경우
  if (ageGrade === AgeGrade.Nineteen) {
    // 유저 나이 정보가 없거나 인증 정보가 없는 경우
    if (!userAge || !userAuthenticatedAt) {
      return true;
    }

    // 유저 나이가 19세 미만이고 인증을 받은 상태라면 더이상 재인증 받지 않는다.
    if (userAge < AGE_GRADE_TO_NUMBER_MAP[AgeGrade.Nineteen]) {
      return false;
    }

    // 19세 이상인 경우 & 본인인증 1년 지났으면 재인증 필요
    return getIsNowOverAYear(userAuthenticatedAt);
  }

  return false;
}
